/**
 *
 * AbsencesCard
 *
 */

import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

// import useDeviceDetect from 'utils/useDeviceDetect';

// styles
import './style.scss';

// antd component
import { Card, Select } from 'antd';

// helper
import {
  getAbsenceCoursesTime,
  getAbsenceMedMoreRange,
} from 'utils/helpers/helper.generateData';
// periods
import {
  getSchoolDaySecond,
  getActualStartYear,
  getActualEndYear,
  getCurrentSemesterDates,
} from 'utils/moment/datesCalc.utils';
import {
  secondsToTimeLabelAbs,
  isDatesBetween,
  getDaysBetweenDates,
} from 'utils/moment/moment.utils';
import {
  ABSENCES_DURATIONS,
  ABSENCES_DURATIONS_STUDENT,
} from 'utils/helpers/helper.constant';

function AbsencesCard({ title, absences, className, variant, ...rest }) {
  const childClassNames = classNames('details-card--absences', className);
  //const { isMobile } = useDeviceDetect();

  const now = moment();
  const dateFormat = 'DD-MM-YYYY';
  const yearStartOn = getActualStartYear();
  const currentSemester = getCurrentSemesterDates();
  const yearEndOn = getActualEndYear();

  const [type, setType] = useState('all');
  const [activeTab, setActiveTab] = useState('month');

  const [contentList, setContentList] = useState({
    month: '--',
    semester: '--',
    year: '--',
  });

  const tabList = [
    {
      key: 'month',
      tab: 'Mois',
    },
    {
      key: 'semester',
      tab: 'Semestre',
    },
    {
      key: 'year',
      tab: 'Année',
    },
  ];

  const getAbsensesHourAll = (
    absences,
    periodStart,
    periodEnd,
    typeAbs = 'all',
  ) => {
    let totalHourInSec = 0;

    if (absences && absences.length > 0) {
      const filtredAbs =
        typeAbs != 'all'
          ? absences.filter(element => element?.type == typeAbs)
          : absences;

      filtredAbs &&
        filtredAbs.length > 0 &&
        filtredAbs.map(element => {
          if (element?.type == 'sickness') {
            const isBetween = isDatesBetween(
              moment(periodStart, dateFormat).format(dateFormat),
              moment(periodEnd, dateFormat).format(dateFormat),
              moment(element?.date).format(dateFormat),
            );

            if (element?.duration !== 'more' && isBetween) {
              if (element?.duration == 'day') {
                totalHourInSec += getSchoolDaySecond();
              } else {
                totalHourInSec += getSchoolDaySecond() / 2;
              }
            } else if (element?.duration == 'more' && isBetween) {
              let timeRange = getAbsenceCoursesTime(element);
              const el = timeRange[0];
              totalHourInSec += el?.totalSec || 0;
            }
          } else if (
            element?.type !== 'sickness' &&
            element?.duration !== 'more'
          ) {
            const hasRecurring = element?.recurring
              ? element?.recurring
              : false;

            /*  if (!hasRecurring) { */
            if (element?.duration !== 'more') {
              const isBetween = isDatesBetween(
                moment(periodStart, dateFormat).format(dateFormat),
                moment(periodEnd, dateFormat).format(dateFormat),
                moment(element?.date).format(dateFormat),
              );
              if (isBetween) {
                let timeRange = getAbsenceCoursesTime(element);
                const el = timeRange[0];
                totalHourInSec += el?.totalSec || 0;
              }
            } else if (element?.duration == 'more') {
              const dates = getDaysBetweenDates(
                element?.date_from,
                element?.date_to,
              );

              const isBetweenDates = dates.filter(dateS => {
                const isBetween = isDatesBetween(
                  moment(periodStart, dateFormat).format(dateFormat),
                  moment(periodEnd, dateFormat).format(dateFormat),
                  moment(dateS, dateFormat).format(dateFormat),
                );
                return isBetween && dateS;
              });
              const finalDatesAmount = isBetweenDates.length;

              const rangeData = getAbsenceMedMoreRange(element);
              const oneDateCost = rangeData?.totalSec / dates.length;

              totalHourInSec += oneDateCost * finalDatesAmount || 0;
            }
            /*       } else {
              // every_day, every_week, every_month
              const elH = getHoursElementByRecurring(element, periodStart, periodEnd, hasRecurring)


              if (element?.duration !== 'more') {

                const isBetween = isDatesBetween(
                  moment(periodStart, dateFormat).format(dateFormat),
                  moment(periodEnd, dateFormat).format(dateFormat),
                  moment(element?.date).format(dateFormat),
                );
                if (isBetween) {
                  let timeRange = getAbsenceCoursesTime(element);
                  const el = timeRange[0];
                  totalHourInSec += el?.totalSec || 0;
                }

              }
            } */
          }
        });
    }
    return totalHourInSec;
  };

  /*
  const getHoursElementByRecurring = (element, periodStart, periodEnd, recurringType) => {
    switch (recurringType) {
      case 'every_day':
        let hours = 0;
        if (element?.duration !== 'more') {

        } else {

        }
        return hours;

      case 'every_week':
        let hoursWeek = 0;
        if (element?.duration !== 'more') {

        } else {

        }
        return hoursWeek;

      case 'every_month':
        let hoursMonth = 0;
        if (element?.duration !== 'more') {

        } else {

        }
        return hoursMonth;

    }
  }
*/

  const getHourByPeriod = (array, period, type = 'all') => {
    let periodStart = yearStartOn;
    let periodEnd = yearEndOn;

    switch (period) {
      case 'annee':
        periodStart = yearStartOn;
        periodEnd = yearEndOn;
        break;
      case 'semestre':
        periodStart = currentSemester?.start;
        periodEnd = currentSemester?.end;
        break;
      case 'mois':
        const startOfMonth = now
          .clone()
          .startOf('month')
          .format('DD.MM.YYYY HH:mm');
        const endOfMonth = now
          .clone()
          .endOf('month')
          .format('DD.MM.YYYY HH:mm');
        periodStart = startOfMonth;
        periodEnd = endOfMonth;
        break;
    }

    const allHour = getAbsensesHourAll(array, periodStart, periodEnd, type);
    return (
      <div className={`absence-content ${period}`}>
        <p>{allHour != 0 ? secondsToTimeLabelAbs(allHour) : 0}</p>
      </div>
    );
  };

  useEffect(() => {
    if (absences && absences.length > 0) {
      setContentList({
        ...contentList,
        mois: getHourByPeriod(absences, 'mois', type),
        semestre: getHourByPeriod(absences, 'semestre', type),
        annee: getHourByPeriod(absences, 'annee', type),
      });
    }
  }, [absences, type]);

  const onTabChange = key => setActiveTab(key);

  const handleChangeType = value => {
    setType(value);
  };

  return (
    <Card
      className={childClassNames}
      bordered={false}
      tabList={tabList}
      activeTabKey={activeTab}
      tabBarExtraContent={
        <div className="header-side">
          <div className="title">{title}</div>
          <div className="select-type">
            <Select
              defaultValue="all"
              onChange={handleChangeType}
              value={type}
              dropdownMatchSelectWidth={false}
              getPopupContainer={trigger => trigger.parentElement}
            >
              <Select.Option value="all">Tous les motifs</Select.Option>
              <Select.Option value="medical">Médicale</Select.Option>
              <Select.Option value="nonMedical">Non-médicale</Select.Option>
              <Select.Option value="sickness">Maladie</Select.Option>
            </Select>
          </div>
        </div>
      }
      onTabChange={onTabChange}
      {...rest}
    >
      {/* {contentList[activeTab]} */} {/*commented temproerly */}
      {variant == 'student'
        ? ABSENCES_DURATIONS_STUDENT[type][activeTab]
        : ABSENCES_DURATIONS[type][activeTab]}
    </Card>
  );
}

AbsencesCard.defaultProps = {
  title: 'Heure(s) d’absence',
  mode: 'simple',
  variant: 'absences',
  absences: [],
};
AbsencesCard.propTypes = {
  mode: PropTypes.oneOf(['simple', 'complex']),
  variant: PropTypes.oneOf(['student', 'absences']),
  title: PropTypes.string,
  absences: PropTypes.oneOfType([
    PropTypes.array.isRequired,
    PropTypes.bool.isRequired,
    PropTypes.string.isRequired,
  ]),
};

export default memo(AbsencesCard);
